'use client';

import Button from '~/components/Button';
import TruncatedText from '~/components/TruncatedText';
import { cn } from '~/lib/utils';
import { XMarkIcon } from '@heroicons/react/24/outline';

type DrawerHeaderProps = {
  title: React.ReactNode;
  meta?: React.ReactNode;
  trailing?: React.ReactNode;
  onClose: () => void;
  className?: string;
};

export default function DrawerHeader({
  title,
  meta,
  trailing,
  onClose,
  className,
}: DrawerHeaderProps) {
  return (
    <header
      className={cn(
        'border-border/60 flex shrink-0 items-start gap-2 border-b px-5 py-3.5',
        className,
      )}
    >
      <Button
        type="button"
        size="icon-sm"
        variant="ghost"
        aria-label="Close"
        title="Close"
        className="text-muted-foreground -ml-1 shrink-0"
        label={<XMarkIcon className="size-5" strokeWidth={2} aria-hidden />}
        onClick={onClose}
      />
      <div className="min-w-0 flex-1">
        <div className="flex min-h-8 min-w-0 items-center">
          {typeof title === 'string' ? (
            <TruncatedText as="h2" className="text-foreground text-base leading-5 font-semibold tracking-tight">
              {title}
            </TruncatedText>
          ) : (
            <h2 className="text-foreground min-w-0 flex-1 truncate text-base leading-5 font-semibold tracking-tight">
              {title}
            </h2>
          )}
        </div>
        {typeof meta === 'string' ? (
          <TruncatedText as="div" className="text-muted-foreground text-xs leading-4">
            {meta}
          </TruncatedText>
        ) : meta ? (
          <div className="text-muted-foreground truncate text-xs leading-4">{meta}</div>
        ) : null}
      </div>
      {trailing ? <div className="flex min-h-8 shrink-0 items-center gap-0.5">{trailing}</div> : null}
    </header>
  );
}
